'use client'

import type { KeenSliderInstance } from 'keen-slider/react'
import type { RefObject } from 'react'
import { useCallback, useEffect, useLayoutEffect, useState } from 'react'

export const useRailArrowPosition = (
  instanceRef: RefObject<KeenSliderInstance | null>,
  containerRef: RefObject<HTMLDivElement | null>,
  setHideLeft: (value: boolean) => void,
  setHideRight: (value: boolean) => void
) => {
  const [arrowPosition, setArrowPosition] = useState({
    vertical: 0,
  })
  const updateSize = useCallback(() => {
    // get the first image of carousel to calculate the center of the arrows
    const firstImage: HTMLImageElement | null | undefined =
      containerRef.current?.querySelector('.keen-slider__slide img')

    if (!firstImage || !containerRef.current || !instanceRef.current) return

    const imageHeight = firstImage?.offsetHeight
    setArrowPosition({
      // middle of the image minus half the size of the arrow
      vertical: imageHeight ? imageHeight / 2 + 10 : 0,
    })

    setHideLeft(instanceRef.current?.track.details.rel === 0)
    setHideRight(
      instanceRef.current?.track.details.maxIdx === instanceRef.current?.track.details.rel
    )
  }, [containerRef, instanceRef, setHideLeft, setHideRight])

  // make sure the arrow position is updated on browser resizing
  useLayoutEffect(() => {
    const onLayoutChange = () => requestAnimationFrame(updateSize)
    window.addEventListener('resize', onLayoutChange)
    window.addEventListener('scroll', onLayoutChange)
    return () => {
      window.removeEventListener('resize', onLayoutChange)
      window.removeEventListener('scroll', onLayoutChange)
    }
  }, [updateSize])

  useEffect(() => {
    setTimeout(() => {
      updateSize()
    }, 1)
  }, [updateSize])

  return arrowPosition
}
